import "./Avatar.scss"
import classNames from "classnames";
import applicationConfiguration from "../../config/applicationConfiguration";

const Avatar = ({ name, surname, url, color, onClick, className }) => {
    const baseUrl = (applicationConfiguration.apiUrl ?? "").replace(/\/+$/, "");
    const imageUrl = url ? `${baseUrl}/api/avatars/${url}` : null;
    const initials = `${name?.[0] ?? ''} ${surname?.[0] ?? ''}`

    return (
        <div
            onClick={onClick}
            className={classNames("wrapper", { "clickable": onClick }, className)}
        >
            {
                imageUrl ?
                    <img src={imageUrl} className="profile" alt="Profile" />
                    :
                    <span className={classNames("profile", { "color": !color })} style={color ? { backgroundColor: color } : {}}>
                        {initials}
                    </span>
            }
        </div>
    );
};

export default Avatar;